import { ENV } from '@env';

export const isDev = (): boolean => {
  return ENV === 'DEV';
};

export default isDev;
